import { render } from "./IndustriesView.vue?vue&type=template&id=6f36cb4c&scoped=true"
import script from "./IndustriesView.vue?vue&type=script&scoped=true&lang=js"
export * from "./IndustriesView.vue?vue&type=script&scoped=true&lang=js"

import "./IndustriesView.vue?vue&type=style&index=0&id=6f36cb4c&scoped=true&lang=css"

import exportComponent from "C:\\Source\\LETC\\LETC_VueRouterWeb\\letc_vr_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f36cb4c"]])

export default __exports__